'use client';

import { ReactNode } from 'react';

import {
    Align,
    Box,
    BoxContent,
    DirectionEnum,
    FlexBox,
    FlexItem,
    Image,
    Justify,
    Price,
    Sticker,
    VariantState,
} from '@bytel/trilogy-react';

import { OptionType } from '@app-types/product';

interface OptionWithPriceProps {
    period?: string;
    subTitleClassName?: string;
    titleClassName?: string;
    className?: string;
    priceLevel?: number;
    children?: ReactNode;
    updatable?: boolean;
    handleDelete?: () => void;
    option: OptionType;
}

export function OptionWithPrice({
    period,
    children,
    priceLevel,
    updatable,
    handleDelete,
    option,
}: Readonly<OptionWithPriceProps>) {
    const { prices: amount, image, small_image, promoLabel: subTitle, name: alt } = option;
    const displayImage = image || small_image;
    const imagePath = displayImage?.startsWith('/') ? displayImage : `/${displayImage}`;
    const imageUrl = displayImage ? `https://www.bouyguestelecom.fr${imagePath}` : '';

    return (
        <Box shadowless flat>
            <BoxContent>
                {subTitle && (
                    <div className='is-hidden-tablet'>
                        <Sticker small label={subTitle} variant={VariantState.ACCENT} />
                    </div>
                )}

                <FlexBox align={Align.CENTER} direction={DirectionEnum.ROW}>
                    <FlexItem>
                        <FlexBox align={Align.CENTER} justify={Justify.SPACE_BETWEEN}>
                            {displayImage && <Image src={imageUrl} height={60} alt={alt ?? "Icone d'option"} />}
                            <FlexBox justify={Justify.END} align={Align.END} gap={0} direction={DirectionEnum.COLUMN}>
                                {subTitle && (
                                    <Sticker
                                        className='is-hidden-mobile'
                                        small
                                        variant={VariantState.ACCENT}
                                        label={subTitle}
                                    />
                                )}
                                <Price
                                    amount={amount?.final}
                                    period={period}
                                    level={priceLevel}
                                    hideCents={false}
                                    align={Align.END}
                                />
                            </FlexBox>
                            {children}
                        </FlexBox>
                    </FlexItem>
                    {updatable && (
                        <FlexItem narrow>
                            <button className='link button-clear' onClick={handleDelete}>
                                Supprimer
                            </button>
                        </FlexItem>
                    )}
                </FlexBox>
            </BoxContent>
        </Box>
    );
}
